import { FileText } from "lucide-react";
import { resolveMediaUrl } from "@/lib/utils";
import type { CommentAttachment } from "../types";

export function CommentAttachmentPreview({
	attachment,
}: {
	attachment: CommentAttachment;
}): React.ReactElement {
	if (attachment.kind === "image") {
		return (
			<img
				src={resolveMediaUrl(attachment.url)}
				alt={attachment.filename}
				className="mt-3 max-h-48 rounded-lg border object-cover"
			/>
		);
	}

	return (
		<a
			href={resolveMediaUrl(attachment.url)}
			target="_blank"
			rel="noreferrer"
			className="mt-3 flex items-center gap-2 rounded-lg border p-3 text-sm hover:bg-muted"
		>
			<FileText className="h-4 w-4" />
			<span>Open attachment: {attachment.filename}</span>
		</a>
	);
}
